module.exports = __webpack_public_path__ + "static/media/icon-x.f33ab30b.svg";